"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcodeSectorsWrapper$ = exports.OutcodeSectorsWrapper$outboundSchema = exports.OutcodeSectorsWrapper$inboundSchema = void 0;
exports.outcodeSectorsWrapperToJSON = outcodeSectorsWrapperToJSON;
exports.outcodeSectorsWrapperFromJSON = outcodeSectorsWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.OutcodeSectorsWrapper$inboundSchema = z.object({
    count: z.number().int(),
    id: z.string(),
    sectors: z.array(z.string()),
    type: z.literal("Sectors in an Outcode").default("Sectors in an Outcode")
        .optional(),
});
/** @internal */
exports.OutcodeSectorsWrapper$outboundSchema = z.object({
    count: z.number().int(),
    id: z.string(),
    sectors: z.array(z.string()),
    type: z.literal("Sectors in an Outcode").default("Sectors in an Outcode"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutcodeSectorsWrapper$;
(function (OutcodeSectorsWrapper$) {
    /** @deprecated use `OutcodeSectorsWrapper$inboundSchema` instead. */
    OutcodeSectorsWrapper$.inboundSchema = exports.OutcodeSectorsWrapper$inboundSchema;
    /** @deprecated use `OutcodeSectorsWrapper$outboundSchema` instead. */
    OutcodeSectorsWrapper$.outboundSchema = exports.OutcodeSectorsWrapper$outboundSchema;
})(OutcodeSectorsWrapper$ || (exports.OutcodeSectorsWrapper$ = OutcodeSectorsWrapper$ = {}));
function outcodeSectorsWrapperToJSON(outcodeSectorsWrapper) {
    return JSON.stringify(exports.OutcodeSectorsWrapper$outboundSchema.parse(outcodeSectorsWrapper));
}
function outcodeSectorsWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutcodeSectorsWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutcodeSectorsWrapper' from JSON`);
}
//# sourceMappingURL=outcodesectorswrapper.js.map